<aside class="admin-sidebar">
  <div class="admin-sidebar__brand">
    <div class="admin-sidebar__logo">
      <img src="assets/images/logos/ICXBEE.svg" alt="ICXBee" class="admin-sidebar__logo-image" />
    </div>
    <p class="admin-sidebar__tagline">Backoffice</p>
  </div>

  <nav class="admin-sidebar__nav" aria-label="Main navigation">
    <ul class="admin-nav">
      @for (item of menuItems; track item.route) {
        <li class="admin-nav__item">
          <a
            class="admin-nav__link"
            [routerLink]="item.route"
            routerLinkActive="admin-nav__link--active"
            [routerLinkActiveOptions]="{ exact: item.route === 'dashboard' }"
          >
            <span class="admin-nav__icon" [attr.data-icon]="item.icon" aria-hidden="true"></span>
            <span class="admin-nav__label">{{ item.label }}</span>
          </a>
        </li>
      }
    </ul>
  </nav>

  <div class="admin-sidebar__footer">
    <button type="button" class="admin-nav__logout" (click)="logout()">
      <span class="admin-nav__icon admin-nav__icon--logout" aria-hidden="true"></span>
      <span class="admin-nav__label">Logout</span>
    </button>

    <div class="admin-sidebar__profile">
      <div class="admin-sidebar__avatar">{{ userInitials() }}</div>
      <div class="admin-sidebar__user">
        <span class="admin-sidebar__name">{{ userName() }}</span>
        @if (userEmail()) {
          <span class="admin-sidebar__email">{{ userEmail() }}</span>
        }
      </div>
    </div>
  </div>
</aside>
